// extracted by mini-css-extract-plugin
export var aircallIframe = "_kh-3";
export var fabContainer = "_kh-5";
export var fabRinging = "_kh-6";
export var loadingOverlay = "_kh-4";
export var pulse = "_kh-7";
export var widgetContent = "_kh-2";
export var widgetPanel = "_kh-0";
export var widgetPanelExpanded = "_kh-1";